/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import * as React from "react";
import type { SVGIconProps } from "../../svgIconProps";
import { IconSize } from "../../iconTypes";
import { SVGIconContainer } from "../../svgIconContainer";

export const Fullscreen: React.FC<SVGIconProps> = React.forwardRef<any, SVGIconProps>(({size = IconSize.STANDARD, ...props}, ref) => {
    const isLarge = size! >= IconSize.LARGE;
    const pixelGridSize = isLarge ? IconSize.LARGE : IconSize.STANDARD;
    const translation = `${-1 * pixelGridSize / 0.014705882352941176 / 2}`;
    const style = { transformOrigin: "center" };
    return (
        <SVGIconContainer iconName="fullscreen" ref={ref} size={size} {...props}>
            <path
                d={isLarge ? "M170 170V453.3333333333334H283.3333333333333V283.3333333333335H453.3333333333333V170H170zM906.6666666666666 170V283.3333333333335H1076.6666666666665V453.3333333333334H1190V170H906.6666666666666zM170 906.6666666666669V1190H453.3333333333333V1076.6666666666667H283.3333333333333V906.6666666666669H170zM1076.6666666666665 906.6666666666669V1076.6666666666667H906.6666666666666V1190H1190V906.6666666666669H1076.6666666666665z" : "M136 136V362.6666666666667H226.6666666666667V226.6666666666667H362.6666666666667V136H136zM725.3333333333334 136V226.6666666666667H861.3333333333334V362.6666666666667H952V136H725.3333333333334zM136 725.3333333333333V952H362.6666666666667V861.3333333333333H226.6666666666667V725.3333333333333H136zM861.3333333333334 725.3333333333333V861.3333333333333H725.3333333333334V952H952V725.3333333333333H861.3333333333334z"}
                fillRule="evenodd"
                transform={`scale(0.014705882352941176, -0.014705882352941176) translate(${translation}, ${translation})`}
                style={style}
            />
        </SVGIconContainer>
   );
});
Fullscreen.displayName = `Blueprint5.Icon.Fullscreen`;
export default Fullscreen;
